/**
 * Coalesce concurrent calls to the same async loader into one promise.
 */
export function dedupeRequest(key, loader) {
  if (!dedupeRequest._inFlight) {
    dedupeRequest._inFlight = new Map();
  }

  const inFlight = dedupeRequest._inFlight;
  if (inFlight.has(key)) {
    return inFlight.get(key);
  }

  const promise = Promise.resolve()
    .then(loader)
    .finally(() => {
      inFlight.delete(key);
    });

  inFlight.set(key, promise);
  return promise;
}
